//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('accessInfo', {
//        templateUrl: 'views/components/views/accessInfo/accessInfo.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'accessInfoService', function ($stateParams, utilityService, accessInfoService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                setting: {},
//                itemsListSubscriptions: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await accessInfoService.getAccessInfo({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadSubscriptions() {
//                if (utilityService.validateParmsValue(vm.model.setting.page_heading) !== true) return;

//                return vm.model.itemsListSubscriptions = await accessInfoService.listSubscriptions(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadSubscriptions();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
